import React, { useCallback } from 'react';
import { useMutation, useQueryClient } from '@gogame/query';

import { markMessage } from 'scenes/AIChatbot/sources/messages';
import {
  markMessage as key,
  messages,
} from 'scenes/AIChatbot/data/queryKeyFactory';
import { DISLIKE_MARK, NEUTRAL_MARK } from 'scenes/AIChatbot/constants';
import {
  CHAT_ID,
  MESSAGE_ID,
} from 'scenes/AIChatbot/components/FeedbackDialog/constants';
import { useFeedback } from './useFeedback';

export const useDislikeMessage = () => {
  const [feedback] = useFeedback();
  const queryClient = useQueryClient();
  const mutation = useMutation(key(), markMessage, {
    errorMessage: (e) => e.message,
    refresh: false,
  });

  const handleAction = useCallback(
    async ({ chatId, messageId }) => {
      let markValue = DISLIKE_MARK;
      queryClient.setQueriesData(
        {
          queryKey: messages(chatId),
          exact: false,
        },
        (oldData = {}) => {
          const message = oldData.find((el) => el.id === messageId);
          if (!message) return oldData;
          if (message.mark === DISLIKE_MARK) {
            markValue = NEUTRAL_MARK;
          }
          message.mark = markValue;
          return oldData;
        }
      );
      await mutation.mutateAsync({
        mark: markValue,
        chatId,
        messageId,
      });

      await feedback({
        [CHAT_ID]: chatId,
        [MESSAGE_ID]: messageId,
      });
    },
    [mutation, queryClient, feedback]
  );
  return [handleAction, mutation];
};
